import ApproveReview from './ApproveReview';

export default ApproveReview;
